import React, { useState, useEffect } from "react";

function ActionCard({
  selectedStudent,
  taskList,
  selectedTasks,
  selectAll,
  showTaskList,
  cardPosition,
  actionCardRef,
  handleCloseCard,
  setShowTaskList,
  handleTaskSelection,
  handleSelectAll,
  handleRetake,
  handleParentReport,
  handleTeacherReport,
  toAllStudentResults,
  toReportCards,
  setViewParent,
  setViewTeacher,
  assessmentName,
}) {
const studentIdArray = Array.isArray(selectedStudent.id) 
  ? selectedStudent.id 
  : [selectedStudent.id];
  
  const [retakeError, setRetakeError] = useState(false);

  console.log(studentIdArray, "studentIdArray");

  // We'll maintain our own local state for the "All Tasks" checkbox
  const [localSelectAll, setLocalSelectAll] = useState(false);

  // When selectAll prop changes, update our local state
  useEffect(() => {
    setLocalSelectAll(selectAll);
  }, [selectAll]);

  // Function to handle the local checkbox change
  const handleLocalSelectAll = () => {
    const newState = !localSelectAll;
    setLocalSelectAll(newState);
    handleSelectAll(); // Call the parent handler
  };

  return (
    <div
      ref={actionCardRef}
      style={{
        position: "absolute",
        top: `${cardPosition.top}px`,
        left: `${cardPosition.left}px`,
        zIndex: 1000,
        display: "flex",
        width: "320px",
        padding: "16px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        flexShrink: 0,
        borderRadius: "8px",
        border: "1px solid #E5E7EB",
        background: "#FFF",
        boxShadow:
          "0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px 0px rgba(0, 0, 0, 0.05)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          alignSelf: "stretch",
        }}
      >
        <p
          style={{
            margin: 0,
            color: "#000",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "24px",
          }}
        >
          Actions
        </p>
        <button
          onClick={handleCloseCard}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          ✕
        </button>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "16px",
          alignSelf: "stretch",
          overflowY: "auto",
        }}
      >
        {/* Retake Tasks Section */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <p
              style={{
                margin: 0,
                color: "#000",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "20px",
              }}
            >
              Retake tasks
            </p>
          </div>

          <button
            style={{
              display: "flex",
              padding: "8px 12px",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "8px",
              alignSelf: "stretch",
              borderRadius: "6px",
              border: "1px solid rgba(156, 163, 175, 1)",
              background: "rgba(156, 163, 175, 1)",
              color: "#FFF",
              cursor: "pointer",
            }}
            onClick={() => {
              console.log(
                "🔄 Toggling Task List, Previous State:",
                showTaskList
              );
              setShowTaskList(!showTaskList);
            }}
          >
            <span>
              {showTaskList ? "Hide tasks" : "Select tasks to retake"}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          {/* Task List (Expands when button is clicked) */}
          {showTaskList && taskList.length > 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
                alignSelf: "stretch",
              }}
            >
              {taskList.map((task) => {
                console.log(`Rendering task: ${task.name} with ID: ${task.answerid}`);
                return (
                  <label
                    key={`${task.answerid}-${task.name}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      alignSelf: "stretch",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedTasks.includes(task.answerid)}
                      onChange={() => {
                        console.log(
                          "🛠️ Task Clicked:",
                          task.name,
                          "ID:",
                          task.answerid
                        );
                        handleTaskSelection(task.answerid);
                      }}
                      style={{
                        width: "16px",
                        height: "16px",
                      }}
                    />
                    <span
                      style={{
                        color: "#000",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "20px",
                      }}
                    >
                      {task.name}
                    </span>
                  </label>
                );
              })}
              {/* Select All Option - Using our local state instead of the prop */}
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  alignSelf: "stretch",
                }}
              >
                <input
                  type="checkbox"
                  checked={localSelectAll}
                  onChange={handleLocalSelectAll}
                  style={{
                    width: "16px",
                    height: "16px",
                  }}
                />
                <span
                  style={{
                    color: "#000",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  }}
                >
                  All tasks
                </span>
              </label>
            </div>
          ) : (
            showTaskList && (
              <p style={{ textAlign: "center", color: "red" }}>
                ⚠️ No tasks found
              </p>
            )
          )}

          {/* Retake Button */}
          <button
            style={{
              display: "flex",
              padding: "8px 12px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              alignSelf: "stretch",
              borderRadius: "6px",
              border: "1px solid #3B82F6",
              background: "#3B82F6",
              color: "#FFF",
              cursor: "pointer",
            }}
            onClick={() => {
              if (selectedTasks.length === 0) {
                setRetakeError(true);
                setTimeout(() => setRetakeError(false), 3000); // Hide error after 3 seconds
              } else {
                setRetakeError(false);
                handleRetake();
              }
            }}
          >
            Retake
          </button>

          {/* Error message for retake button */}
          {retakeError && (
            <div style={{
              color: "red",
              fontSize: "12px",
              textAlign: "center",
              width: "100%",
              marginTop: "-4px"
            }}>
              ⚠️ Please select at least one task to retake
            </div>
          )}
        </div>

        {/* Report Cards Section */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <p
              style={{
                margin: 0,
                color: "#000",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "20px",
              }}
            >
              {assessmentName?.split(" ")[1]} Report Cards
            </p>
          </div>

          <div
            style={{
              display: "flex",
              padding: "8px 12px",
              alignItems: "center",
              gap: "8px",
              alignSelf: "stretch",
              borderRadius: "6px",
              border: "1px solid #E5E7EB",
            }}
          >
            <input
              type="text"
              value={selectedStudent.name}
              readOnly
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                background: "transparent",
                color: "#000",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            />
            <button
              onClick={handleCloseCard}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              ✕
            </button>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "8px",
              alignSelf: "stretch",
            }}
          >
            <button
              className="blue-action-button"
              onClick={() => {
                setViewParent(true);
                setViewTeacher(false);
                toAllStudentResults(studentIdArray, true, false);
              }}
            >
              Simple
            </button>
            <button
              className="blue-action-button"
              onClick={() => {
                setViewParent(false);
                setViewTeacher(true);
                toAllStudentResults(studentIdArray, false, true);
              }}
            >
              Detailed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActionCard;